import { render, staticRenderFns } from "./hello-world.vue?vue&type=template&id=f270d368&scoped=true&"
import script from "./hello-world.vue?vue&type=script&lang=js&"
export * from "./hello-world.vue?vue&type=script&lang=js&"
import style0 from "./hello-world.vue?vue&type=style&index=0&id=f270d368&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f270d368",
  null
  
)

export default component.exports